import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  UntypedFormControl,
  UntypedFormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { SignupService } from 'src/app/services/signup.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment.prod';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import * as AuthActions from '../../../store/shared/auth/auth.actions';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { allCountriesList } from 'src/app/shared/countryList';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
declare var $;

@Component({
  selector: 'app-become-a-b2b-user',
  templateUrl: './become-a-b2b-user.component.html',
  styleUrls: ['./become-a-b2b-user.component.css'],
})
export class BecomeAB2BUserComponent implements OnInit {
  token;
  userID;
  b2bUser;
  facebookLoginErrorMessage;
  socialLoginToken;
  passingSignupData = false;
  googleRecapthaSiteKey = '6LfzUlUaAAAAAKKv0UBaepUWBOJKiZ62xqtvqREh';
  counrtyList = allCountriesList;
  phoneCodeCountrySelection;
  phoneSelectedCountry;
  phoneSelectedCountryCode;
  searchCountryName;
  countries = allCountriesList;
  phoneSelectedCountryFlag;
  userCountry = 'AU';

  selectPhoneCountry(country) {
    this.phoneSelectedCountry = country;
    this.phoneSelectedCountryFlag = country.country_flag;
    this.phoneSelectedCountryCode = country.country_phone_code;
    this.phoneCodeCountrySelection = false;
  }

  form = new UntypedFormGroup(
    {
      firstName: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(3),
      ]),
      lastName: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(3),
      ]),
      email: new UntypedFormControl('', [
        Validators.required,
        Validators.email,
      ]),
      password: new UntypedFormControl('', Validators.required),
      repassword: new UntypedFormControl('', Validators.required),
      country: new UntypedFormControl('', Validators.required),
      recaptcha: new UntypedFormControl('', Validators.required),
      mail_permission: new UntypedFormControl(false),
      type: new UntypedFormControl(5),
      b2b_short_description: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(400),
      ]),
      acceptance_terms: new FormControl(false, Validators.required),
      company_name: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(50),
      ]),
      vat_number: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(50),
      ]),
    },
    { validators: this.controlPasswordValidator('password', 'repassword') }
  );
  constructor(
    public signUpService: SignupService,
    private toastr: ToastrService,
    private router: ActivatedRoute,
    private route: Router,
    private store: Store<AppState>,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private gtmService: GoogleTagManagerService
  ) {
    this.router.paramMap.subscribe((params) => {
      this.lang = params.get('lang');
    });
    this.iconRegistry.addSvgIcon(
      'checkbox',
      this.sanitizer.bypassSecurityTrustResourceUrl('path/to/checkbox-icon.svg')
    );
    this.signUpService.getAllCountries().subscribe((data) => {
      this.counrtyList = data['data'];
      this.countries = this.counrtyList;
      this.signUpService.getUserIPData().subscribe((data) => {
        const countryCode = data['country'] === 'GB' ? 'UK' : data['country'];
        this.form.patchValue({ country: countryCode });
        this.userCountry = countryCode;
        this.phoneSelectedCountry = this.countries.find(
          (country) => country.code === countryCode
        );
        if (this.phoneSelectedCountry) {
          const { country_phone_code, country_flag } = this.phoneSelectedCountry;
          this.phoneSelectedCountryCode = country_phone_code;
          this.phoneSelectedCountryFlag = country_flag;
        } else {
          console.warn(`Could not find country with code: ${countryCode}`);
        }
      });
    });
  }
  lang;
  isForm1Completed = false;
  currentStep = 0;
  stepperStep2State = 'waiting';
  descriptionCharLen = 0;
  changeUserCountry(ev) {}
  ngOnInit(): void {
    this.store.select('auth').subscribe((state) => {
      this.token = state.token;
      this.userID = state.user?.id;
      this.b2bUser = state.user;
      if (
        this.b2bUser &&
        this.b2bUser.type === 5 &&
        this.b2bUser.is_email_verified &&
        this.b2bUser.is_phone_verified
      ) {
        if (this.b2bUser?.is_b2b_user_active) {
          return this.route.navigate(
            ['/','b2b', 'shipment-create'],
            { relativeTo: this.router }
          );
        } else {
          return this.route.navigate(['/','b2b', 'shipments'], {
            relativeTo: this.router,
          });
        }
      } else if (
        this.b2bUser &&
        this.b2bUser.type === 5 &&
        (!this.b2bUser.is_email_verified || !this.b2bUser.is_phone_verified)
      ) {
        this.route.navigate(['/','verification'], {
          relativeTo: this.router,
        });
      } else if (this.b2bUser && this.b2bUser.type !== 5) {
        this.route.navigate(['/','home'], {
          relativeTo: this.router,
        });
      }
    });
  }

  keyPressAlphabethic(event) {
    var inp = String.fromCharCode(event.keyCode);

    if (/[a-zA-Z]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  checkInputValidations() {
    let hasError = false;

    if (this.form.controls.firstName.status == 'INVALID') {
      this.toastr.error('Please enter your first name', 'Error');
      this.form.controls.firstName.markAsTouched();
      hasError = true;
    }

    if (this.form.controls.lastName.status == 'INVALID') {
      this.toastr.error('Please enter your last name', 'Error');
      this.form.controls.lastName.markAsTouched();
      hasError = true;
    }

    if (this.form.controls.email.status == 'INVALID') {
      this.toastr.error('Please enter your email', 'Error');
      this.form.controls.email.markAsTouched();
      hasError = true;
    }
    if (this.form.controls.company_name.status == 'INVALID') {
      this.toastr.error('Please enter Company Name', 'Error');
      this.form.controls.company_name.markAsTouched();
      hasError = true;
    }
    if (this.form.controls.vat_number.status == 'INVALID') {
      this.toastr.error('Please enter VAT Number', 'Error');
      this.form.controls.company_name.markAsTouched();
      hasError = true;
    }

    if (this.form.controls.b2b_short_description.status == 'INVALID') {
      this.toastr.error(
        'Please enter a short description about your business',
        'Error'
      );
      this.form.controls.b2b_short_description.markAsTouched();
      hasError = true;
    }

    if (this.form.controls.password.status == 'INVALID') {
      this.toastr.error('Please enter your password', 'Error');

      this.form.controls.password.markAsTouched();
      hasError = true;
    }
    if (this.form.controls.repassword.status == 'INVALID') {
      this.toastr.error('Please retype your password', 'Error');
      this.form.controls.repassword.markAsTouched();
      hasError = true;
    }

    if (this.form.controls.country.status == 'INVALID') {
      this.toastr.error('Please select your country', 'Error');
      this.form.controls.country.markAsTouched();
      hasError = true;
    }
    if (this.form.controls.acceptance_terms.value == false) {
      this.toastr.error('Please read & accept B2B User Agreement', 'Error');
      this.form.controls.acceptance_terms.markAsTouched();
      hasError = true;
    }

    if (this.form.controls.recaptcha.status == 'INVALID') {
      this.toastr.error('Please check the captcha', 'Error');

      this.form.controls.recaptcha.markAsTouched();
      hasError = true;
    }
    return hasError;
  }

  completeStep1() {
    if (!this.checkInputValidations()) {
      const payload = {
        country_code: this.form.controls.country.value,
        email: this.form.controls.email.value,
        google: {
          action: 'B2B_USER_SIGN_UP',
          token: this.form.controls.recaptcha.value,
        },
        mail_permission: this.form.controls.mail_permission.value,
        name: this.form.controls.firstName.value,
        password: this.form.controls.password.value,
        surname: this.form.controls.lastName.value,
        type: this.form.controls.type.value,
        b2b_short_description: this.form.controls.b2b_short_description.value,
        company_name: this.form.controls.company_name.value,
        vat_number: this.form.controls.vat_number.value,
      };
      this.signUpService.signUpwithEmailv2(payload).subscribe({
        next: (data) => {
          if (data['result']['status'] === 200) {
            this.toastr.success('Successfully Signed Up', 'Success');
            const user: object = data['data']['user'];
            this.store.dispatch(
              AuthActions.LoginSuccess({ token: data['data']['token'], user })
            );
            this.passingSignupData = false;

            if (!user['is_email_verified'] || !user['is_phone_verified']) {
              const gtmTag = {
                event: 'gtmB2BSignUp',
                data: {
                  email: user['email'],
                },
              };
              this.gtmService.pushTag(gtmTag);
              this.route.navigate(['/','verification']);
              return;
            } else {
              this.currentStep = 1;
              this.stepperStep2State = 'done';
            }
            this.route.navigate(['/','verification']);
          } else {
            this.toastr.error(data['data']['result']['message'], 'Error');
            this.passingSignupData = false;
          }
        },
        error: (error) => {
          this.passingSignupData = false;
        },
      });
    } else {
    }
  }
  password;
  repassword;
  writingPassword(event) {
    this.password = event.target.value;
  }
  writingRePassword(event) {
    this.repassword = event.target.value;
  }
  private controlPasswordValidator(
    controlPassword: string,
    controlRepassword: string
  ): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const fGroup = control as UntypedFormGroup;
      const password = fGroup.get(controlPassword)?.value;
      const confirmPassword = fGroup.get(controlRepassword)?.value;
      if (password === confirmPassword) {
        return null;
      } else {
        return { passwordsDoNotMatch: true };
      }
    };
  }
}
